exports.f = require('../internals/well-known-symbol');



//////////////////
// WEBPACK FOOTER
// ./~/@firebase/polyfill/~/core-js/internals/wrapped-well-known-symbol.js
// module id = 59
// module chunks = 1